export default function PageHeader({ kicker, title, action }) {
    return (
        <header className="flex items-end justify-between flex-wrap gap-4 mb-8">
            <div>
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-primary">
                    {kicker}
                </p>
                <h1 className="font-display font-black text-4xl md:text-5xl tracking-tight mt-2">
                    {title}
                </h1>
            </div>
            {action}
        </header>
    );
}
